<!--
 * @Descripttion:
 * @Version: 1.0
 * @Author: +C
 * @Date: 2022-02-18 09:32:43
 * @LastEditors: +C
 * @LastEditTime: 2022-02-18 14:55:05
-->
<template>
  <vxe-pager v-bind="tableAttrs" v-on="$listeners">
    <slot></slot>
  </vxe-pager>
</template>

<script>
export default {
  name: 'DxxPager',
  //页面引用的组件
  components: {},
  //父页面传递参数
  props: {},
  data() {
    return {};
  },
  //监控计算变量
  computed: {

    // 计算属性的 getter
    tableAttrs: function () {

      //默认属性
      let defaultArr = {
        border: true,
        layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']
      }
      var newArr = Object.assign(defaultArr, this.$attrs);

      return newArr
    }

    // :show-overflow="true" align="center" border="inner" :highlight-hover-row="true" header-row-class-name="dxx-table-header" header-cell-class-name="dxx-table-header-cell"
  },
  //监听
  watch: {},
  //页面的构造方法
  created() { },
  //父页面定义方法给子页面inject调用
  providee() { return {} },
  //子组件调用注入到父页面providee
  inject: [],
  //dom加载完
  mounted() { },
  //页面的自定义方法
  methods: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/table/pager.vue